const timeToStringFormat = (date: Date) => {
  const hours = date.getHours().toString().padStart(2, '0');
  const minutes = date.getMinutes().toString().padStart(2, '0');
  const ampm = date.getHours() >= 12 ? 'PM' : 'AM';
  const formattedHours = (date.getHours() % 12 || 12)
    .toString()
    .padStart(2, '0');
  return `${formattedHours}:${minutes} ${ampm}`;
};

export default timeToStringFormat;
